import {CxEvent} from '@spartacus/core';

export class AfterPageViewEvent extends CxEvent {
  static readonly type: string = 'AfterPageViewEvent';
}
